import SectionHeading from "@/components/base/SectionHeading";
import { requirements, safetyTips } from "@/mocks/homeContent";

export default function Requirements() {
  return (
    <section id="requirements" className="scroll-mt-24 w-full bg-background-50 py-16 md:py-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="设备要求与安全"
          title="下载前先对照，安装更省心"
          desc="安装前确认手机是否满足最低要求，能让下载与运行更顺畅；同时注意从正规入口获取安装包，保障使用安全。"
        />

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <h3 className="flex items-center gap-2 text-base font-semibold text-foreground-950">
              <i className="ri-smartphone-line text-primary-600" aria-hidden="true"></i>
              设备与系统要求
            </h3>
            <div className="mt-4 border border-background-200 rounded-lg overflow-hidden">
              <div className="hidden sm:grid grid-cols-12 bg-background-100 px-5 py-3 text-xs font-medium text-foreground-600">
                <span className="col-span-3">项目</span>
                <span className="col-span-4">建议配置</span>
                <span className="col-span-5">说明</span>
              </div>
              <div className="divide-y divide-background-200">
                {requirements.map((row) => (
                  <div key={row.item} className="grid grid-cols-1 sm:grid-cols-12 gap-1 sm:gap-0 px-5 py-4">
                    <span className="sm:col-span-3 text-sm font-medium text-foreground-900">
                      {row.item}
                    </span>
                    <span className="sm:col-span-4 text-sm text-primary-700">
                      {row.value}
                    </span>
                    <span className="sm:col-span-5 text-xs md:text-sm text-foreground-600">
                      {row.note}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-1">
            <h3 className="flex items-center gap-2 text-base font-semibold text-foreground-950">
              <i className="ri-shield-star-line text-accent-600" aria-hidden="true"></i>
              安全下载建议
            </h3>
            <div className="mt-4 space-y-4">
              {safetyTips.map((tip) => (
                <div
                  key={tip.title}
                  className="bg-background-100 border border-background-200 rounded-lg p-4"
                >
                  <h4 className="text-sm font-semibold text-foreground-950">{tip.title}</h4>
                  <p className="mt-1.5 text-xs md:text-sm leading-relaxed text-foreground-600">
                    {tip.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}